import { useEffect, useState, useMemo, useCallback } from 'react'
import type { Company } from '../../domain/company'
import { GetCompanyDetailUseCase } from '../../usecases/DetailCompanyUseCase'
import { AxiosCompanyRepository } from '../../infrastructure/AxiosCompanyRepository'

export function useCompanyDetail(id: string) {
    const [company, setCompany] = useState<Company | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    const repository = useMemo(() => new AxiosCompanyRepository(), [])

    const fetchCompany = useCallback(async () => {
        try {
            setLoading(true)
            setError(null)

            const useCase = new GetCompanyDetailUseCase(repository)
            const companyId = Number.parseInt(id, 10)
            const data = await useCase.execute(companyId)

            setCompany(data)
        } catch (err) {
            setError(
                err instanceof Error
                    ? err.message
                    : 'Error al cargar la empresa'
            )
        } finally {
            setLoading(false)
        }
    }, [id, repository])

    useEffect(() => {
        if (id) {
            fetchCompany()
        }
    }, [id, fetchCompany])

    const mutate = useCallback(async () => {
        return await fetchCompany()
    }, [fetchCompany])

    return { company, loading, error, mutate }
}
